/** График в ответе ассистента: горизонтальные полоски.
 *
 *  ПОЧЕМУ ПОЛОСКИ, А НЕ ПИРОГ. Одним видом закрываются все три вопроса, ради
 *  которых график и нужен: «по категориям», «по месяцам», «сравни два периода».
 *  У пирога с ними хуже — доли меньше десяти процентов на телефоне не читаются,
 *  а сравнение двух чисел он показывает как две дольки, что просто хуже двух
 *  полосок. Второй вид добавим, когда найдётся вопрос, на который полоски
 *  отвечают плохо.
 *
 *  ПОЧЕМУ ПОДПИСЬ НАД ПОЛОСКОЙ, А НЕ СЛЕВА. Слева она съедает ширину у самой
 *  полоски, и на узком экране длинное «переводы/люди» отняло бы половину.
 *
 *  РИСУЕМ ТО, ЧТО ПРИСЛАЛИ. Числа приходят от модели, но к ней они попали из
 *  инструментов, то есть посчитаны приложением. Своей арифметики здесь нет —
 *  только доля от наибольшего, и та ради пикселей.
 */
import type { Chart } from "../lib/answerBlocks.ts";
import { formatNumber } from "../lib/money.ts";

export function AnswerChart({ chart }: { chart: Chart }) {
  const values = chart.rows.map(([, v]) => Math.abs(Number(v)));
  const top = Math.max(...values, 0);

  return (
    <figure style={{ margin: "var(--s-3) 0 0" }}>
      {chart.title && (
        <figcaption style={{ fontSize: "var(--f-caption)", color: "var(--text-muted)",
                             marginBottom: "var(--s-2)" }}>
          {chart.title}
        </figcaption>
      )}
      <div style={{ display: "flex", flexDirection: "column", gap: "var(--s-2)" }}>
        {chart.rows.map(([label, value], i) => (
          <div key={`${label}-${i}`}>
            <div style={{ display: "flex", alignItems: "baseline", gap: "var(--s-2)",
                          marginBottom: 3 }}>
              <span style={{ flexGrow: 1, minWidth: 0, fontSize: "var(--f-caption)",
                             overflow: "hidden", textOverflow: "ellipsis",
                             whiteSpace: "nowrap" }}>
                {label}
              </span>
              <span className="num" style={{ fontSize: "var(--f-caption)",
                                             color: "var(--text-muted)",
                                             whiteSpace: "nowrap" }}>
                {formatNumber(value)}
              </span>
            </div>
            <div style={{ height: 8, borderRadius: "var(--r-bar)",
                          background: "var(--surface-2)", overflow: "hidden" }}>
              {/* Пустая полоска у нуля честнее полоски в один пиксель:
                  «ноль» и «немного» не должны выглядеть одинаково. */}
              <div style={{ height: "100%", borderRadius: "var(--r-bar)",
                            width: `${share(values[i] ?? 0, top)}%`,
                            background: "var(--data)" }} />
            </div>
          </div>
        ))}
      </div>
    </figure>
  );
}

/** Доля от наибольшего. Единственное место, где числа становятся пикселями. */
function share(value: number, top: number): number {
  if (!Number.isFinite(value) || !Number.isFinite(top) || top <= 0) return 0;
  return Math.min(100, Math.max(0, (value / top) * 100));
}
